import React from 'react';
import { Container } from 'reactstrap';
import Header from '../components/header';
import { element } from 'prop-types';

const Layout = ({ children }) => (
  <Container>
    <Header />
    {children}
  </Container>
)

Layout.propTypes = {
  children: element,
}

Layout.defaultProps = {
  children: null,
}

export default Layout